import { AxiosError } from 'axios'
import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { logError } from '@/utils/logError'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            staleTime: 1000 * 60 * 3,
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            const context = {
                source: 'queryCache',
                queryKey: query.queryKey,
                queryHash: query.queryHash,
                state: query.state,
                options: query.options,
                meta: query.meta,
            }

            logError(error, {
                ...context,
                response:
                    error instanceof AxiosError
                        ? (error.response?.data ?? error.message)
                        : error.message,
                traceId:
                    error instanceof AxiosError
                        ? error.config?.headers['X-Trace-Id']
                        : undefined,
            })
        },
    }),
    mutationCache: new MutationCache({
        onError: (error, variables, context, mutation) => {
            const sentryContext = {
                source: 'mutationCache',
                variables,
                context,
                state: mutation.state,
                options: mutation.options,
                meta: mutation.meta,
            }

            logError(error, {
                ...sentryContext,
                response:
                    error instanceof AxiosError
                        ? (error.response?.data ?? error.message)
                        : error.message,
                traceId:
                    error instanceof AxiosError
                        ? error.config?.headers['X-Trace-Id']
                        : undefined,
            })
        },
    }),
})
